import { toast } from '@shigo-ui/ui';

import { dashboardT } from './messages';

/**
 * Copies text and reports the outcome with a toast. Resolves `true` when the text was copied;
 * never rejects, so callers can `void` it from click handlers.
 */
export async function copyToClipboard(
  text: string,
  {
    successMessage,
    errorMessage = dashboardT('common.copyError'),
  }: { successMessage: string; errorMessage?: string | undefined },
) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMessage);
    return true;
  } catch {
    toast.error(errorMessage);
    return false;
  }
}
